import React from 'react';
import {Box, CircularProgress, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useSuggestiveSellingPending} from '../hooks/use-suggestive-selling-pending';

const SuggestiveSellingInlinePending = ({
                                            pendingKey,
                                            showLabel = true,
                                            size = 20,
                                            sx,
                                        }) => {
    const {t} = useTranslation('dialogs', {keyPrefix: 'app-specific.suggestive-selling'});
    const pending = useSuggestiveSellingPending(pendingKey);

    if (!pending) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                ...sx,
            }}
            aria-busy
            aria-live={'polite'}
        >
            <CircularProgress size={size} color={'secondary'}/>
            {
                showLabel &&
                <Typography variant={'caption'} color={'text.secondary'}>
                    {t('checkingAddons')}
                </Typography>
            }
        </Box>
    );
};

export default SuggestiveSellingInlinePending;
